/**
 * @generated SignedSource<<4bee9b5965d042eb1f0be40f1b800d43>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TVTeamScheduleEditAssigneesPopoverMutation$variables = {
  employeeIds: ReadonlyArray<string>;
  routineId: string;
  sequenceNumber: number;
};
export type TVTeamScheduleEditAssigneesPopoverMutation$data = {
  readonly routine: {
    readonly occasion: {
      readonly updateAssignedEmployees: {
        readonly assigned: ReadonlyArray<{
          readonly employee: {
            readonly id: string;
          } | null;
          readonly id: string;
        }>;
        readonly id: string;
      };
    };
  } | null;
};
export type TVTeamScheduleEditAssigneesPopoverMutation = {
  response: TVTeamScheduleEditAssigneesPopoverMutation$data;
  variables: TVTeamScheduleEditAssigneesPopoverMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "employeeIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "routineId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sequenceNumber"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "routineId"
      }
    ],
    "concreteType": "RoutineMutation",
    "kind": "LinkedField",
    "name": "routine",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "sequenceNumber",
            "variableName": "sequenceNumber"
          }
        ],
        "concreteType": "RoutineOccasionMutation",
        "kind": "LinkedField",
        "name": "occasion",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "employeeIds",
                "variableName": "employeeIds"
              }
            ],
            "concreteType": "RoutineOccasion",
            "kind": "LinkedField",
            "name": "updateAssignedEmployees",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AssignedEmployee",
                "kind": "LinkedField",
                "name": "assigned",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Employee",
                    "kind": "LinkedField",
                    "name": "employee",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TVTeamScheduleEditAssigneesPopoverMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TVTeamScheduleEditAssigneesPopoverMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "e4168d5a9c1e3009b8b98024c2bf3aea",
    "id": null,
    "metadata": {},
    "name": "TVTeamScheduleEditAssigneesPopoverMutation",
    "operationKind": "mutation",
    "text": "mutation TVTeamScheduleEditAssigneesPopoverMutation(\n  $routineId: ID!\n  $sequenceNumber: Int!\n  $employeeIds: [ID!]!\n) {\n  routine(id: $routineId) {\n    occasion(sequenceNumber: $sequenceNumber) {\n      updateAssignedEmployees(employeeIds: $employeeIds) {\n        id\n        assigned {\n          id\n          employee {\n            id\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3dc4fd62f83ac22b6433d7ccee945775";

export default node;
